import { useQuery } from "@tanstack/react-query";
import type {
  InvolvementOptionsResponse,
  InvolvementPeriod,
  InvolvementResponse,
} from "@insights/contracts";
import { api } from "../../../api";

export type InvolvementFilters = {
  period: InvolvementPeriod;
  repository: string;
  project: string;
};

export function useInvolvementOptions(
  workspaceId: string | undefined,
  repository: string,
) {
  const query = new URLSearchParams();
  if (repository) {
    query.set("repository", repository);
  }

  return useQuery({
    enabled: Boolean(workspaceId),
    queryKey: ["involvement-options", workspaceId, repository],
    queryFn: () => api<InvolvementOptionsResponse>(
      `/${workspaceId}/involvement/options?${query}`,
    ),
  });
}

export function useInvolvement(
  workspaceId: string | undefined,
  filters: InvolvementFilters,
) {
  const query = new URLSearchParams({
    period: String(filters.period),
    repository: filters.repository,
    project: filters.project,
  });

  return useQuery({
    enabled: Boolean(workspaceId && filters.repository && filters.project),
    queryKey: ["involvement", workspaceId, filters],
    queryFn: () => api<InvolvementResponse>(
      `/${workspaceId}/involvement?${query}`,
    ),
  });
}
